
export default class requestVacios {
  static Depto() {
    return {
      idDepartamento: 0,
      nombre: ""
    };
  }

  static Cliente() {
    return {
      idCliente: 0,
      nombre: "",
      idUsuario: 0
    };
  }
  static Perfil() {
    return {
      idPerfil: 0,
      nombre: ""
    };
  }

  
  static NoConformidadEstado() {
    return {
      idNoConformidadEstado: 0,
      conformidadEstado: ""
    };
  }
  
  static Usuario() {
    return {
      idUsuario: 0,
      nombre: ""
    };
  }

  static Rol() {
    return {
      idRol: 0,
      nombre: ""
    };
  }
  static TipoTarea() {
    return {
      idTipoTarea: 0,
      nombre: ""
    };
  }
  static EstadoTarea() {
    return {
      idEstadoTarea: 0,
      nombre: ""
    };
  }
  static TipoEvento() {
    return {
      idTipoEvento: 0,
      nombre: ""
    };
  }
  static EventoSolicitudEstado() {
    return {
      idEventoSolicitudEstado: 0,
      nombre: ""
    };
  }
  static EventoTipoAsistencia() {
    return {
      idCtrolAsistenciaEv: 0,
      evento: "",
      multipleSeleccion: true,
      activo: true
    };
  }

  static EventoControlAsistencia() {
    return {
      idCtrolAsistenciaEv: 0,
      evento: "",
      multipleSeleccion: false,
      activo: true
    };
  }


  static NoConformidadAccionTipo() {
    return {
      idNoConformidadAccionTipo: 0,
      descripcion: ""
    };
  }
  static Organismo() {
    return {
      CUIT: "",
      Denominacion: ""
    };
  }
  
  // Agrega más métodos estáticos según sea necesario
}